import React from 'react';
import TableC from '../../../basicElement/TableC';
import format from '../../../shared/format';
import { WorkStatus } from '../constants';

export default function PersonInfo(props) {
    const { loading, data } = props;

    const getColumns = () => ([{
        title: '序号',
        dataIndex: 'index',
        key: 'index',
        width: 60,
    }, {
        title: 'CRC姓名',
        dataIndex: 'userCompellation',
        key: 'userCompellation',
        width: 100,
    }, {
        title: 'CRC工号',
        dataIndex: 'employeeCode',
        key: 'employeeCode',
        width: 100,
    }, {
        title: '职位级别',
        dataIndex: 'positionName',
        key: 'positionName',
        width: 100,
    }, {
        title: '入职时间',
        dataIndex: 'joinTime',
        key: 'joinTime',
        width: 100,
        render: (text) => format('date', text),
    }, {
        title: '主管领导姓名',
        dataIndex: 'leaderUserCompellation',
        key: 'leaderUserCompellation',
        width: 100,
    }, {
        title: '主管领导工号',
        dataIndex: 'leaderEmployeeCode',
        key: 'leaderEmployeeCode',
        width: 100,
    }, {
        title: '在职状态',
        dataIndex: 'workStatus',
        key: 'workStatus',
        width: 100,
        render: (text) => WorkStatus[text],
    }, {
        title: '新人独立承接项目时间',
        dataIndex: 'independentInvTime',
        key: 'independentInvTime',
        width: 100,
        render: (text) => format('date', text),
    }, {
        title: '离职时间',
        dataIndex: 'leftTime',
        key: 'leftTime',
        width: 100,
        render: (text) => format('date', text),
    }, {
        title: '离职原因',
        dataIndex: 'firstReasonName',
        key: 'firstReasonName',
        width: 100,
    }]);

    const getDataSource = () => {
        return data || [];
    };

    return (
        <div>
            <div style={{ lineHeight: '48px' }}>3.被带教人员的个人信息明细</div>
            <TableC
                scrollY={300}
                loading={loading}
                columns={getColumns()}
                data={getDataSource()}
                className="personInfo"
            />
        </div>
    );
}



// WEBPACK FOOTER //
// ./src/components/home/TeachingDetail/tables/PersonInfo.js